import type { Ring } from "../data/site-boundary";

/** Ray-casting point-in-polygon for a closed ring of [lng, lat] positions. */
export function pointInPolygon(lng: number, lat: number, ring: Ring): boolean {
  let inside = false;
  for (let i = 0, j = ring.length - 1; i < ring.length; j = i++) {
    const [xi, yi] = ring[i]!;
    const [xj, yj] = ring[j]!;
    const intersects = yi > lat !== yj > lat && lng < ((xj - xi) * (lat - yi)) / (yj - yi) + xi;
    if (intersects) {
      inside = !inside;
    }
  }
  return inside;
}

/** Signed area for tie-breaking nested/overlapping polygons (larger rings are usually outer). */
export function ringSignedArea(ring: Ring): number {
  let area = 0;
  for (let i = 0, j = ring.length - 1; i < ring.length; j = i++) {
    const [xi, yi] = ring[i]!;
    const [xj, yj] = ring[j]!;
    area += (xj + xi) * (yj - yi);
  }
  return area / 2;
}
